import { Input } from "antd";
import styles from "./Search.module.scss";
import Icon from "../Icon/Icon";
import origSearch from "@assets/redesign/icons/searchButton.svg";
import wlpSearch from "@components/WLP202603/assets/redesign/icons/searchButton.svg";
import { SearchProps as AntSearchProps } from "antd/es/input";
import classNames from "classnames";
import { CloseCircleFilled } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { WLP202603 } from "../../../../config";

const search = WLP202603 ? wlpSearch : origSearch;

type SearchProps = {
  label?: React.ReactNode;
  wrapClassName?: string;
} & AntSearchProps;

function Search({
  wrapClassName,
  ...props
}: SearchProps) {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState(props.value || props.defaultValue);
  const clear = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return <label className={classNames(styles.container, wrapClassName)}>
    {props.label}
    <Input.Search
      placeholder={formatMessage({ id: "general.search" })}
      {...props}
      allowClear={props.allowClear && { clearIcon: <span ref={clear}></span> }}
      value={value}
      onChange={e => {
        setValue(e.currentTarget.value);
        props.onChange?.(e);
      }}
      prefix={props.allowClear && !props.disabled && !props.readOnly ? <div className={styles.prefix}>
        {props.prefix}
        <CloseCircleFilled
          className={classNames(styles.clear, { [styles.hide]: !value })}
          onClick={() => clear.current?.click()}
        />
      </div> : props.prefix}
      className={classNames(props.className, { [styles.search]: !props.enterButton, [styles.noValue]: !value && props.allowClear && !props.disabled && !props.readOnly })}
      enterButton={props.enterButton || <Icon src={search} className={styles.icon} noHover />}
    />
  </label>
}

export { Search };
